(ns app.front.view.application.withdrawal
  (:require [app.domain.util :as du]
            [app.front.ui.termination-info :as termination-info]))

(defn show-withdrawal-info? [phase-entity]
  (contains? #{:process.state/withdrawn
               :process.state/withdrawal-requested
               :process.state/archived}
             (:process/state phase-entity)))

(defn withdrawal-info [{:keys [fsm-target] :as props}]
  (when (show-withdrawal-info? fsm-target)
    [termination-info/termination-info fsm-target (assoc props
                                                         :reason-attr :application/withdrawal-reason
                                                         :by-attr :application/withdrawal-requested-by
                                                         :ts-attr :application/withdrawal-requested-ts
                                                         :descr-tr-key :withdraw/requested-by)]))

(defn show-cancel-withdrawal-info? [phase-entity]
  (not (show-withdrawal-info? phase-entity)))

(defn cancel-withdrawal-info [{:keys [fsm-target] :as props}]
  (when (show-cancel-withdrawal-info? fsm-target)
    [termination-info/termination-info fsm-target (assoc props
                                                         :reason-attr :application/cancel-withdrawal-reason
                                                         :by-attr :application/cancel-withdrawal-by
                                                         :ts-attr :application/cancel-withdrawal-ts
                                                         :descr-tr-key :withdraw/requested-by)]))

(defn show-rejection-info? [phase-entity]
  (contains? #{:process.state/rejected
               :process.state/archived}
             (:process/state phase-entity)))

(defn rejection-info [{:keys [fsm-target] :as props}]
  (when (show-rejection-info? fsm-target)
    [termination-info/termination-info fsm-target (assoc props
                                                         :reason-attr :application/rejection-reason
                                                         :by-attr :application/rejection-by
                                                         :ts-attr :application/rejection-ts
                                                         :descr-tr-key :rejection/by)]))

(def show-refusal-info?
  (du/in-state-fn :state.application/refused
                  :state.application/archived))

(defn refusal-info [{:keys [application] :as props}]
  (when (show-refusal-info? application)
    [termination-info/termination-info application (assoc props
                                                          :reason-attr :application/refusal-reason
                                                          :by-attr :application/refusal-by
                                                          :ts-attr :application/refusal-ts
                                                          :descr-tr-key :refusal/by)]))

(def show-denial-info?
  (du/in-state-fn :state.application/denied
                  :state.application/archived))

(defn denial-info [{:keys [application] :as props}]
  (when (show-denial-info? application)
    [termination-info/termination-info application (assoc props
                                                          :reason-attr :application/denial-reason
                                                          :by-attr :application/denial-by
                                                          :ts-attr :application/denial-ts
                                                          :descr-tr-key :denial/by
                                                          :rich-text-reason? true)]))

(def show-lapse-info?
  (du/in-state-fn :execution.state/lapsed))

(defn lapse-info [{:keys [execution] :as props}]
  (when (show-lapse-info? execution)
    [termination-info/termination-info execution (assoc props
                                                        :reason-attr :execution/lapsed-reason
                                                        :by-attr :execution/lapsed-by
                                                        :ts-attr :execution/lapsed-ts
                                                        :descr-tr-key :lapsed/by
                                                        :rich-text-reason? true)]))

(def show-blocking-info?
  (du/in-state-fn :execution.state/blocked-work-order))

(defn blocking-info [{:keys [execution] :as props}]
  (when (show-blocking-info? execution)
    [termination-info/termination-info execution (assoc props
                                                        :reason-attr :execution/blocked-reason
                                                        :by-attr :execution/blocked-by
                                                        :ts-attr :execution/blocked-ts
                                                        :descr-tr-key :blocked/by)]))
